import React, { useState } from "react";
import HeadOverView from "./AssetComp/HeadOverView";
import StationOverView from "./AssetComp/StationOverView";
import RemarkTable from "./AssetComp/RmarksTable";
import AssetRemark from "./AssetComp/AssetRemarks";
import { RiBarChartGroupedFill } from "react-icons/ri";
import { MdOutlineStackedBarChart } from "react-icons/md";
import StackedShiftWiseData from "./AssetComp/StackedShiftWiseData";
import DataSummary from "./AssetComp/DataSummary";
import CauseWiseAFGraph from "./AssetComp/CauseWiseAFGraph";
import GroupedTrendChart from "../../CHARTS/GroupedTrendChart";
import { flattenData } from "../../Utilitie";
import GraphFromSummeryData from "./AssetComp/AFSummary/GraphFromSummeryData";
const OverviewMaster = ({ data, from }) => {
  const [active, setActive] = useState("Grouped");
  const [causeWiseChart, setCauseWiseChart] = useState(false);
  const [subCauseWiseChart, setSubCauseWiseChart] = useState(false);
  const tempData = data && flattenData(data);
  const [selectedHead, setSelectedHead] = useState({
    ASSET_GROUP: "UNUSUAL",
    F_YEAR: "2024_25",
    MAIN_CAUSE_DESC: "",
    Month: "",
    SUB_CAUSE_DESC: "",
    SECTION_NAME: "",
  });
  return (
    <div className="m-2">
      {data && (
        <div>
          {from === "drm diary" || (
            <div className="row ">
              <div className="col-md-6 ">
                <div className="row ">
                  <div className="col-md-12">
                    {" "}
                    <HeadOverView
                      from={"asset"}
                      height={220}
                      data={data}
                      setSelectedHead={setSelectedHead}
                    />
                  </div>
                  <div className="col-md-12">
                    <HeadOverView
                      from={"Section"}
                      height={220}
                      data={data}
                      selectedHead={selectedHead}
                      setSelectedHead={setSelectedHead}
                    />
                  </div>{" "}
                  <div className="col-md-12">
                    <HeadOverView
                      from={"Coa Section"}
                      height={220}
                      data={data}
                      selectedHead={selectedHead}
                      setSelectedHead={setSelectedHead}
                    />
                  </div>
                </div>
              </div>{" "}
              <div className="col-md-6 ">
                <AssetRemark
                  data={data}
                  path={selectedHead}
                  from={"OverView"}
                />
              </div>
            </div>
          )}
          {/* //////////////////////////////////////////////////////////////////////////////////////////////////////// */}
          <div>
            {" "}
            <GraphFromSummeryData data={data} />
          </div>
          {/* //////////////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="row ">
            <div className="col-md-4 " style={{ height: "400px" }}>
              <div className="">
                <div className=" papaDivNM mt-0 p-1 bg-dark text-white d-flex justify-content-center">
                  <div className="d-flex justify-content-center  mt-0 p-1">
                    <h5 className=" ">Cause wise </h5>
                    <button
                      className="btn btn-sm btn-outline-light"
                      onClick={() => setCauseWiseChart(!causeWiseChart)}
                    >
                      {" "}
                      {causeWiseChart
                        ? "Switch to Year Wise"
                        : "Switch to Shift Wise"}
                    </button>
                  </div>
                </div>
                <CauseWiseAFGraph data={data} causeWiseChart={causeWiseChart} />
              </div>
            </div>
            <div className="col-md-8" style={{ minHeight: "400px" }}>
              {" "}
              <div className="">
                {" "}
                <div className=" papaDivNM mt-0 p-1 bg-dark text-white d-flex justify-content-center">
                  {" "}
                  <h5 className="">Sub Cause wise {"  "}</h5>
                  <div className="">
                    <button
                      className="btn btn-sm btn-outline-light ms-1"
                      onClick={() => setSubCauseWiseChart(!subCauseWiseChart)}
                    >
                      {" "}
                      {subCauseWiseChart
                        ? "Switch to Year Wise"
                        : "Switch to Shift Wise"}
                    </button>
                    <button
                      className={`btn btn-sm btn-outline-light  m-1 ${
                        active === "Stacked" && "active"
                      } `}
                      onClick={() => {
                        setActive("Stacked");
                      }}
                    >
                      <MdOutlineStackedBarChart />
                    </button>
                    <button
                      className={`btn btn-sm btn-outline-light m-1  ${
                        active === "Grouped" && "active"
                      } `}
                      onClick={() => {
                        setActive("Grouped");
                      }}
                    >
                      <RiBarChartGroupedFill />
                    </button>
                  </div>
                </div>
                {active === "Stacked" && (
                  <StackedShiftWiseData
                    data={data}
                    from={"Sub Cause"}
                    subCauseWiseChart={subCauseWiseChart}
                  />
                )}
                {active === "Grouped" && (
                  <HeadOverView
                    from={"Sub Cause"}
                    subCauseWiseChart={subCauseWiseChart}
                    sectionName={selectedHead.SECTION_NAME}
                    data={data}
                    selectedHead={selectedHead}
                    setSelectedHead={setSelectedHead}
                  />
                )}
              </div>
            </div>
            {data && (
              <div
                className="fade-in-up mt-3 p-2"
                style={{ background: "rgba(0,0,0,0)" }}
              >
                <h5 className="text-center fw-bold mb-3">
                  Sub-Cause Month wise Trend
                </h5>
                <GroupedTrendChart data={tempData} />
              </div>
            )}
            {/* <div className="col-md-4"> */}
            {/* <DataSummary data={data} fy={data && data[0]?.F_YEAR} /> */}
            {/* </div> */}
          </div>
        </div>
      )}
    </div>
  );
};
export default OverviewMaster;
